import { OAuthCallbackKey } from '@common/oAuth/constants';
import { useSearchParams } from 'react-router-dom';

import { returnFromSsoAutoLogin } from './returnFromSsoAutoLogin';

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();

  if (window.opener) {
    window.opener.window.postMessage(
      {
        type: OAuthCallbackKey,
        payload: { code: searchParams.get('code'), state: searchParams.get('state') }
      },
      '*'
    );
  } else {
    returnFromSsoAutoLogin();
  }
  return null;
}
